export const zoomInitialState = 'zoomInitialState'
export const zoomInState = 'zoomInState'
export const zoomOutState = 'zoomOutState'
export const zoomDoubleInState = 'zoomDoubleInState'
export const zoomInConstant = 0.3

export const zoomIn = ({ scale }) => {
  const newScale = scale + zoomInConstant
  document
    .getElementsByName('viewport')[0]
    .setAttribute('content', 'width=900,initial-scale=' + newScale)
}

export const zoomOut = ({ scale }) => {
  document
    .getElementsByName('viewport')[0]
    .setAttribute('content', 'width=900,initial-scale=' + scale)
}

export const scrollIntoView = ({ element }) => {
  !!element &&
    element.scrollIntoView &&
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    })
}

export const getGlobalZoomState = () => {
  if (!window.globalZoomState) {
    window.globalZoomState = zoomOutState
  }  
  return window.globalZoomState
}

export const setGlobalZoomState = value => {
  window.globalZoomState = value
}

export const isMobile = () =>
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
